import { Link } from 'react-router-dom';
import { Callout } from 'frosted-ui';
import { ExclamationTriangle16 } from '@frosted-ui/icons';
import { ApiRequestError } from '../services/apiErrors';

export interface Problem {
  message: string;
  blockingTest?: { id: string; name: string };
}

/**
 * What went wrong, for a seller. A 4xx explains itself and retrying won't help,
 * so its own words show; anything else gets `fallback`.
 */
export function problemFrom(err: unknown, fallback: string): Problem {
  if (err instanceof ApiRequestError && err.status === 404) {
    return { message: "We couldn't find that. It may have been deleted, so reload this page." };
  }
  if (err instanceof ApiRequestError && err.status && err.status < 500) {
    return { message: err.message, blockingTest: err.blockingTest };
  }
  return { message: fallback };
}

/** A problem with an action: the test in the way, when one is. */
export default function ProblemCallout({ problem }: { problem: Problem }) {
  return (
    <Callout.Root color="red" role="alert">
      <Callout.Icon>
        <ExclamationTriangle16 />
      </Callout.Icon>
      <Callout.Text>
        {problem.message}
        {problem.blockingTest && (
          <>
            {' '}
            <Link to={`/experiments/${problem.blockingTest.id}`}>
              Open “{problem.blockingTest.name}”
            </Link>
          </>
        )}
      </Callout.Text>
    </Callout.Root>
  );
}
